import { useState } from "react";
import { BioShell, Field, ResultCard, Stat, primaryBtn, BIO_ACCENT } from "./BioShell.jsx";
import { molarity, dilution, round } from "./biocore.js";

export default function Lab() {
  const [mode, setMode] = useState("molarity");

  return (
    <BioShell title="Lab Solutions">
      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        {[["molarity", "Molarity"], ["dilution", "Dilution"]].map(([k, l]) => (
          <button key={k} onClick={() => setMode(k)} style={{ flex: 1, background: mode === k ? BIO_ACCENT : "#1C1E2E", color: mode === k ? "#04240F" : "#9A9DBE", border: "none", borderRadius: 10, padding: "10px 0", fontWeight: 600, fontSize: 14, cursor: "pointer" }}>
            {l}
          </button>
        ))}
      </div>
      {mode === "molarity" ? <Molarity /> : <Dilution />}
    </BioShell>
  );
}

function Molarity() {
  const [moles, setMoles] = useState("");
  const [liters, setLiters] = useState("0.5");
  const [M, setM] = useState("2");
  const [res, setRes] = useState(null);
  const run = () => {
    const p = (x) => (x.trim() === "" ? null : parseFloat(x));
    setRes(molarity({ moles: p(moles), liters: p(liters), molarityVal: p(M) }));
  };
  return (
    <>
      <p style={{ fontSize: 13, color: "#5B5E7A", marginTop: 0 }}>M = mol / L. Fill two, leave the unknown blank.</p>
      <Field label="Moles of solute" suffix="mol" value={moles} onChange={(e) => setMoles(e.target.value)} placeholder="—" inputMode="decimal" />
      <Field label="Volume" suffix="L" value={liters} onChange={(e) => setLiters(e.target.value)} placeholder="—" inputMode="decimal" />
      <Field label="Molarity" suffix="M" value={M} onChange={(e) => setM(e.target.value)} placeholder="—" inputMode="decimal" />
      <button onClick={run} style={primaryBtn}>Solve</button>
      {res && !res.ok && <ResultCard><span style={{ color: "#F8716A" }}>{res.error}</span></ResultCard>}
      {res && res.ok && (
        <ResultCard>
          <Stat label="Moles" value={round(res.result.moles, 5)} unit="mol" />
          <Stat label="Volume" value={round(res.result.liters, 5)} unit="L" />
          <Stat label="Molarity" value={round(res.result.molarityVal, 5)} unit="M" />
        </ResultCard>
      )}
    </>
  );
}

function Dilution() {
  const [c1, setC1] = useState("10");
  const [v1, setV1] = useState("");
  const [c2, setC2] = useState("2");
  const [v2, setV2] = useState("100");
  const [res, setRes] = useState(null);
  const run = () => {
    const p = (x) => (x.trim() === "" ? null : parseFloat(x));
    setRes(dilution({ c1: p(c1), v1: p(v1), c2: p(c2), v2: p(v2) }));
  };
  return (
    <>
      <p style={{ fontSize: 13, color: "#5B5E7A", marginTop: 0 }}>C₁V₁ = C₂V₂. Fill exactly three, leave one blank.</p>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        <Field label="C₁ (stock conc.)" value={c1} onChange={(e) => setC1(e.target.value)} placeholder="—" inputMode="decimal" />
        <Field label="V₁ (stock vol.)" value={v1} onChange={(e) => setV1(e.target.value)} placeholder="—" inputMode="decimal" />
        <Field label="C₂ (final conc.)" value={c2} onChange={(e) => setC2(e.target.value)} placeholder="—" inputMode="decimal" />
        <Field label="V₂ (final vol.)" value={v2} onChange={(e) => setV2(e.target.value)} placeholder="—" inputMode="decimal" />
      </div>
      <button onClick={run} style={primaryBtn}>Solve</button>
      {res && !res.ok && <ResultCard><span style={{ color: "#F8716A" }}>{res.error}</span></ResultCard>}
      {res && res.ok && (
        <ResultCard>
          <Stat label={`Solved for ${res.solvedFor.toUpperCase()}`} value={round(res.result, 5)} unit="" />
          <div style={{ marginTop: 8, fontSize: 12, color: "#5B5E7A" }}>Keep concentration units consistent (both M, or both %). Volume units must match too.</div>
        </ResultCard>
      )}
    </>
  );
}

